const root = document.documentElement;

const PROP_NAME = '--app-layout-scrollbarWidth';

function getScrollbarWidth() {
    const viewportWidth = visualViewport.width;
    const windowInnerWidth = window.innerWidth;

    const scrollbarWidth = windowInnerWidth - viewportWidth;

    return scrollbarWidth;
}

function getPropValue() {
    const propValue = root.style.getPropertyValue(PROP_NAME);

    if (!propValue.endsWith('px')) {
        return null;
    }

    const value = parseFloat(propValue.slice(0, -2));

    return value;
}

let oldValue = null;

const init = () => {
    oldValue = getPropValue();
};

const measure = () => {
    const value = getScrollbarWidth();

    if (value === oldValue) {
        return;
    }

    root.style.setProperty(PROP_NAME, `${value}px`);

    oldValue = value;
};

const onAnimationFrame = () => {
    measure();

    requestAnimationFrame(onAnimationFrame);
};

requestAnimationFrame(onAnimationFrame);

init();
